import { action, observable, runInAction } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import { partnerOrderController } from './partnerOrderController';
import { PartnerOffice } from '../../../partners/store/offices/officesApi';
import { B2BCustomerItem, FindPartnerRequest } from '../../api/partnerAPI';

export interface PartnerOrderStore {
  sto: PartnerOffice[],
  B2BCustomers: B2BCustomerItem[],
  // stoByServiceId: number,
  error: ErrorInterface,
}

export const partnerOrderStore: PartnerOrderStore = observable({
  sto: [],
  // stoByServiceId: undefined,
  B2BCustomers: [],
  error: null,
} as PartnerOrderStore);

export const partnerOrderActions = {

  getServiceOfficeSTO: async (): Promise<void> => {
    // Обрати внимание, что СТО получают по фиксированному сервису
    // Поэтому в течении всей сессии можно не обновлять sto
    if (partnerOrderStore.sto.length === 0) {
      partnerOrderStore.error = null;
      const response = await partnerOrderController.getServiceOfficeSTO(41);
      partnerOrderActions.handleError(response);
      runInAction(() => { partnerOrderStore.sto = response.data; });
    }
  },

  getB2BCustomers: async (): Promise<void> => {
    if (partnerOrderStore.B2BCustomers.length === 0) {
      partnerOrderStore.error = null;
      const response = await partnerOrderController.getB2BCustomers();
      partnerOrderActions.handleError(response);
      runInAction(() => { partnerOrderStore.B2BCustomers = response.data; });
    }
  },

  /* clearSto: action(() => {
    partnerOrderStore.sto = [];
  }), */

  handleError: action((response) => {
    if (response.errorData) {
      const { data } = response;
      partnerOrderStore.error = data;
      throw data;
    }
  }),

  findPartner: async (request: FindPartnerRequest): Promise<void> => {
    const response = await partnerOrderController.findPartner(request);
    partnerOrderActions.handleError(response);
  },

};
